(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrousel-images"] && !Shopify.designMode) return;
  try {
    
const track = document.querySelector('.carousel-track');
const items = Array.from(track.children);
let centerIndex = 0; 

function updateCarousel() {
  const total = items.length;

  const leftIndex  = (centerIndex - 1 + total) % total;
  const rightIndex = (centerIndex + 1) % total;

  items.forEach((item, index) => {
    item.classList.remove('left', 'center', 'right');
    item.style.zIndex = 0;

    item.style.display = 'none';
    item.style.order = 99;

    if (index === leftIndex) {
      item.style.display = 'block';
      item.classList.add('left');
      item.style.order = 1; 
      item.style.zIndex = 1;
    }

    if (index === centerIndex) {
      item.style.display = 'block';
      item.classList.add('center');
      item.style.order = 2; 
      item.style.zIndex = 3;
    }

    if (index === rightIndex) {
      item.style.display = 'block';
      item.classList.add('right');
      item.style.order = 3;   
      item.style.zIndex = 2;
    }
  });
}

document.querySelector('.carousel-btn.prev').addEventListener('click', () => {
  centerIndex = (centerIndex - 1 + items.length) % items.length;
  updateCarousel();
});

document.querySelector('.carousel-btn.next').addEventListener('click', () => {
  centerIndex = (centerIndex + 1) % items.length;
  updateCarousel();
});

window.addEventListener('load', updateCarousel);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-carrousel-brands"] && !Shopify.designMode) return;
  try {
    
function initSwiper() {
  new Swiper('.swiper-container', {
    loop: false,          
    slidesPerView: 5,  
    spaceBetween: 30,
    speed: 400,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      0: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 5 }
    }
  });
}

if (!window.Swiper) {
  var s = document.createElement('script');
  s.src = "https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js";
  s.onload = initSwiper;
  document.head.appendChild(s);

  var l = document.createElement('link');
  l.rel = "stylesheet";
  l.href = "https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css";
  document.head.appendChild(l);
} else {
  initSwiper();
}

  } catch(e) { console.error(e); }
})();
})();
